import { useState } from 'react';

import ButtonGroup from '../ButtonGroup';
import BarChart from '../Chart';
import { S } from '../style';
import { EmployeeAvgYear } from '../type';

function ChartContent() {
  const [year, setYear] = useState<EmployeeAvgYear>(2021);

  return (
    <>
      <S.ChartContent>
        <BarChart year={year} />
      </S.ChartContent>
      <ButtonGroup currentYear={year} onClick={(year) => setYear(year)} />
    </>
  );
}

export default ChartContent;
